import code from "../../assets/images/code.webp";
import bok1 from "../../assets/images/bok1.webp";
import bok2 from "../../assets/images/bok2.webp";
import dott from "../../assets/images/dott.svg";
import bok3 from "../../assets/images/bok3.webp";
import we_mo from "../../assets/images/we_mo.webp";
import we_pc from "../../assets/images/we_pc.webp";
import check_01 from "../../assets/images/check_01.svg";

export default function WeAre() {
  return (
    <div className="container mx-auto p-3 pl-6 flex flex-col md:flex-col lg:flex-row-reverse  gap-10">
      <div className="flex flex-col gap-4 w-full lg:gap-7 ">
        <div className="flex items-center gap-2 w-full ">
          <p className="text-sm md:text-base lg:text-lg font-semibold text-[#033F6A]">
            Chúng tôi là
          </p>
          <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
            <p className="text-sm md:text-base lg:text-lg font-semibold text-white">
              BlueSkyIT
            </p>
          </div>
        </div>
        <div>
          <p className="text-xl md:text-2xl lg:text-3xl text-[#1C9BDB] font-semibold w-full lg:w-[590px] md:w-full">
            Cam kết của chúng tôi đối với sự hài lòng của khách hàng
          </p>
        </div>
        <div>
          <p className="text-base md:text-lg font-normal w-full lg:w-[590px] md:w-full">
            Tại BlueSkyIT, sự hài lòng của khách hàng luôn là tôn chỉ hoạt động.
            Chúng tôi cam kết phục vụ với:
          </p>
        </div>
        <div>
          <ul className="flex flex-col gap-4 relative left-[-40px]">
            <li className="flex items-center gap-4">
              <div className="border border-[#1C9BDB] w-[22px] h-[22px] lg:w-[22px] lg:h-[22px] flex items-center justify-center bg-[#1C9BDB] rounded-full px-1 py-1">
                <img src={check_01} alt="ck" />
              </div>
              <div>
                <p className="text-sm md:text-base font-normal w-[18rem] lg:w-[30rem] md:whitespace-nowrap">
                  100% đội ngũ chuyên gia có kinh nghiệm, trình độ và kỹ năng
                  cao
                </p>
              </div>
            </li>
            <li className="flex items-center gap-4">
              <div className="border border-[#1C9BDB] w-[22px] h-[22px] lg:w-[22px] lg:h-[22px] flex items-center justify-center bg-[#1C9BDB] rounded-full px-1 py-1">
                <img src={check_01} alt="ck" />
              </div>
              <div>
                <p className="text-sm md:text-base font-normal w-[18rem] lg:w-[27rem] md:whitespace-nowrap">
                  Dịch vụ chăm sóc khách hàng 24/7
                </p>
              </div>
            </li>
            <li className="flex items-center gap-4">
              <div className="border border-[#1C9BDB] w-[22px] h-[22px] lg:w-[22px] lg:h-[22px] flex items-center justify-center bg-[#1C9BDB] rounded-full px-1 py-1">
                <img src={check_01} alt="ck" />
              </div>
              <div>
                <p className="text-sm md:text-base font-normal w-[18rem] lg:w-[27rem] md:whitespace-nowrap">
                  Chi phí hợp lý
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className=" w-full lg:w-full ">
        <img src={we_mo} alt="we_mo" className="block lg:hidden" />
        <img
          src={we_pc}
          alt="we_pc"
          className="hidden lg:block object-cover "
        />
      </div>
    </div>
  );
}
